import {BaseClient} from "../../baseclient";
import {WasmExtension} from "../wasm";
import {TokenQueryExtension, TokenQueryExtensionMethods} from "./query";
import {TokenTxExtension, TokenTxExtensionMethods} from "./tx";

export type TokenExtension = TokenQueryExtension & TokenTxExtension;
export type TokenExtensionMethods = TokenQueryExtensionMethods & TokenTxExtensionMethods;

export function TokenExtension<T extends {new (...args: any[]): BaseClient & TokenExtension & WasmExtension}>(constructor: T): T {
  return class extends TokenQueryExtension(TokenTxExtension(constructor)) {};
}

export * from "./amino";
export * from "./query";
export * from "./tx";
